import { Box, Card, Link, Stack, CardContent, Grid2 as Grid } from '@mui/material';

import { useTranslate } from 'src/locales';
import { AuthLoader } from 'src/pages/auth/components/shared/AuthLoader';
import { PasswordField, ChannelStepLayout } from 'src/pages/channel/shared';

import { Iconify } from 'src/components/iconify';
import { Form, Field } from 'src/components/hook-form';

import { useSmsStep3 } from '../hooks';
import { ProviderChip } from './provider-chip';
import { SectionHeader } from './section-header';
import { SetupGuideAlert } from './setup-guide-alert';

export function SMSStep3() {
  const { t } = useTranslate('translation');
  const { methods, isLoading, isNextDisabled, providerType, onSubmit } = useSmsStep3();

  const steps = [
    <>
      {t('FIND_SMS_CONFIG_DETAILS')}{' '}
      <Link
        href={
          providerType === 'twilio' ? 'https://console.twilio.com/' : 'https://console.plivo.com/'
        }
        target="_blank"
        sx={{
          fontWeight: 600,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        {providerType === 'twilio' ? t('TWILIO_CONSOLE') : t('PLIVO_CONSOLE')}
        <Iconify icon="mdi:open-in-new" width={16} height={16} />
      </Link>
    </>,
  ];

  return (
    <>
      {isLoading && <AuthLoader />}

      <Stack spacing={4} sx={{ height: '100%' }}>
        <Form methods={methods} onSubmit={onSubmit}>
          <ChannelStepLayout
            title={t('SMS_CHANNEL_SETUP')}
            subtitle={t('CONFIGURE_YOUR_SMS_PROVIDER_DETAILS')}
            isNextDisabled={isNextDisabled}
          >
            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Card>
                <CardContent sx={{ p: 4 }}>
                  <Stack spacing={4}>
                    <ProviderChip provider={providerType} label={t('SMS_SERVICE_PROVIDER')} />

                    <Grid container spacing={3}>
                      <Grid size={{ xs: 12, md: 6 }}>
                        <Field.Text
                          name="channelName"
                          label={t('CHANNEL_NAME')}
                          placeholder={t('ENTER_CHANNEL_NAME_PLACEHOLDER')}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>

                      <Grid size={{ xs: 12 }}>
                        <SectionHeader
                          title={t('ACCOUNT_CONFIGURATION')}
                          tooltipTitle={t('LEARN_MORE_TOOLTIP')}
                          helpUrl="https://help.twilio.com/articles/14726256820123-What-is-a-Twilio-Account-SID-and-where-can-I-find-it"
                        />
                      </Grid>

                      <Grid size={{ xs: 12, md: 6 }}>
                        <Field.Text
                          name="accountSid"
                          label={t('ACCOUNT_ID')}
                          placeholder={t('ENTER_ACCOUNT_ID')}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>

                      <Grid size={{ xs: 12, md: 6 }}>
                        <PasswordField
                          name="authToken"
                          label={t('AUTH_TOKEN')}
                          placeholder={t('ENTER_AUTH_TOKEN')}
                        />
                      </Grid>

                      <Grid size={{ xs: 12, md: 6 }}>
                        <Field.Text
                          name="srcNumber"
                          label={t('SOURCE_NUMBER')}
                          placeholder={t('ENTER_SOURCE_NUMBER')}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                    </Grid>
                  </Stack>
                </CardContent>
              </Card>

              <SetupGuideAlert title={t('SETUP_GUIDE')} steps={steps} />
            </Box>
          </ChannelStepLayout>
        </Form>
      </Stack>
    </>
  );
}
